// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var ScheduledEventType;
(function (ScheduledEventType) {
    ScheduledEventType["CREATE_REPORT"] = "CREATE_REPORT";
    ScheduledEventType["UPDATE_VOTING_STATUS"] = "UPDATE_VOTING_STATUS";
    ScheduledEventType["CREATE_BOARD"] = "CREATE_BOARD";
    ScheduledEventType["CREATE_KEYS"] = "CREATE_KEYS";
    ScheduledEventType["SET_PUBLIC_KEY"] = "SET_PUBLIC_KEY";
    ScheduledEventType["CREATE_ELECTION_EVENT_BALLOT_STYLES"] = "CREATE_ELECTION_EVENT_BALLOT_STYLES";
    ScheduledEventType["TALLY_ELECTION_EVENT"] = "TALLY_ELECTION_EVENT";
    ScheduledEventType["SEND_TEMPLATE"] = "SEND_TEMPLATE";
})(ScheduledEventType || (ScheduledEventType = {}));
